import { Box, Icon, Link, Typography } from '@mui/material';
import React, { Component } from 'react';
import { TbAlertTriangleFilled } from "react-icons/tb";
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import { CONST_BUSINESS_MAIL, CONST_SITE_LABEL } from './common/Helper';
import './common/Styles.css'
import Copyright from './common/Copyright';
import DebugService from '../services/DebugService';
import { setScopedItem, STORAGE_KEYS } from './common/Helper';
/**
 * Error Boundary Component
 * Currently handling Dashboard flow
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hasError: null,
            error: null,
            errorInfo: null,
        }
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        }
    }

    componentDidCatch(error, errorInfo) {
        DebugService.error('Error caught by ErrorBoundary', error, errorInfo)
        this.setState({
            error,
            errorInfo
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='onboard-request-container'>
                    <Box component="div" className='error-page-container'>
                        <Box className='error-page-header full-width'>
                            <Link title='Home' href="/" className='error-home-link' >
                                <Typography variant="h6" color="inherit">{CONST_SITE_LABEL}</Typography>
                            </Link>

                            <a href={`mailto:${CONST_BUSINESS_MAIL}`} className='error-mail-link'>{CONST_BUSINESS_MAIL}</a>
                        </Box>


                        <Box className='error-content-container'>
                            <Icon className='error-content-icon'>
                                <TbAlertTriangleFilled />
                            </Icon>
                            <Typography variant="h4" className='error-content-text1'>Something Went Wrong!</Typography>

                            <Typography component="p" className='error-content-text2'>
                                The page you are trying to access is currently unavailable.
                                Please try again later....
                            </Typography>
                            <Typography component="p" className='error-content-text2'>
                                <Link
                                  onClick={() => {
                                    setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, CONST_ROUTE_PATH.DASHBOARD)
                                    window.location.href = CONST_ROUTE_PATH.DASHBOARD
                                  }}
                                  className='error-link2'
                                >
                                  Return To Dashboard
                                </Link>
                            </Typography>
                        </Box>


                        <Box className='full-width' >
                            <div className='error-copyright-container'>
                                <Copyright />
                            </div>
                        </Box>
                    </Box>
                </div>
            )
        }

        return this.props.children
    }
}